import React from 'react'
import {
  FormattedMessage,
  injectIntl,
  InjectedIntl,
  InjectedIntlProps
} from 'react-intl'
import moment, { Moment } from 'moment'

interface IProps extends InjectedIntlProps {
  value: Moment,
  intl: InjectedIntl
}

/**
 * @param {IProps} props
 * @return 'DD.MM.YYYY | HH:MM'
 */
const FormattedDateTime = (props: IProps) => (
  (props.value && props.value instanceof moment)
    ? <span>
      {`${props.value.format('DD.MM.YYYY')} | ${props.value.format('HH:mm')}`}
    </span>
    : <FormattedMessage id="date.missing" />
)
const IntlFormattedDateTime = injectIntl(FormattedDateTime)
export { IntlFormattedDateTime as default }
